import { Component, OnDestroy, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { Subscription } from 'rxjs';
import { TareaResponsableService } from '../tarea-responsable/tarea-responsables.service';
import { TareaResponsable } from '../tarea-responsable/tarea-responsable';
import { Usuario } from '../../../../interfaces/usuario';
import { PermisoService } from '../../../../providers/permiso.service';

@Component({
  selector: 'app-listar-tarea-responsables',
  templateUrl: './listar-tarea-responsables.component.html',
  styleUrls: ['./listar-tarea-responsables.component.scss']
})
export class ListarTareaResponsablesComponent implements OnDestroy {
  actualizarTablaTimeout: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga: boolean = true; // primera solicitud a traer datos
  cargandoTimeout: any;
  cargando: boolean = true; // para mostrar el progress-bar luego de un tiempo de busqueda
  tablaTareaResponsablesColumnas = ['usuario', 'nombre', 'apellido', 'fechaCompletada'];
  tareaResponsablesDataSource = new MatTableDataSource();
  getTareaResponsablesSuscripcion = new Subscription();
  tareaResponsablesCount: number = 0;
  IdTarea: number | string = '';
  private _acciones: boolean = false;

  @Input() public set acciones(acciones: boolean) {
    if (acciones) {
      // acciones si
      this.permisoService.tienePermiso('TAREA-RESPONSABLE-ACCIONES').then(tienePermiso => {
        if (tienePermiso) {
          this.tablaTareaResponsablesColumnas.push('acciones');
        }
      });
    } else {
      // acciones no
      this.tablaTareaResponsablesColumnas.forEach((columna: string, index: number) => {
        if (columna == 'acciones') {
          this.tablaTareaResponsablesColumnas.splice(index, 1);
          return;
        }
      });
    }

    this._acciones = acciones;
  }

  public get acciones(): boolean {
    return this._acciones;
  };

  constructor(
    private TareaResponsableService: TareaResponsableService,
    private permisoService: PermisoService
  ) { }

  actualizarTabla(): void {
    clearTimeout(this.actualizarTablaTimeout);
    this.actualizarTablaTimeout = setTimeout(() => {
      clearTimeout(this.cargandoTimeout);
      this.cargandoTimeout = setTimeout(() => { // mostrar cargando si tarda mas de algun tiempo de busqueda
        this.cargando = true;
      }, 750);

      if (this.getTareaResponsablesSuscripcion && !this.getTareaResponsablesSuscripcion.closed) {
        this.getTareaResponsablesSuscripcion.unsubscribe();
      }

      this.getTareaResponsablesSuscripcion = this.TareaResponsableService
        .getTareaResponsables(
          {
            page: null,
            pageSize: null
          },
          {
            sort: null,
            order: null
          },
          {
            IdTarea: this.IdTarea
          }
        )
        .subscribe( // suscribimos una nueva busqueda
          respuesta => {
            if (respuesta.estado == 1 && respuesta.data) {
              if (respuesta.data.total) {
                this.tareaResponsablesCount = respuesta.data.total;
              }

              var tareaResponsables: TareaResponsable[] = []; // array de datos obtenidos
              if (respuesta.data.responsables) {
                respuesta.data.responsables.forEach(tareaResponsable => {
                  tareaResponsables.push(new TareaResponsable(
                    tareaResponsable.IdTareaResponsable,
                    new Usuario(
                      tareaResponsable.usuario.IdUsuario,
                      tareaResponsable.usuario.usuario,
                      null,
                      null,
                      null,
                      tareaResponsable.usuario.nombre,
                      tareaResponsable.usuario.apellido
                    ),
                    tareaResponsable.fechaCompletada
                  ));
                });
              }

              this.tareaResponsablesDataSource.data = tareaResponsables;
            }
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando
          }
        );
    }, (this.flag_primera_carga ? 0 : 220));

    this.flag_primera_carga = false;
  }

  ngOnDestroy() {
    if (this.getTareaResponsablesSuscripcion && !this.getTareaResponsablesSuscripcion.closed) {
      this.getTareaResponsablesSuscripcion.unsubscribe();
    }
  }
}
